import type { ReactElement } from 'react';

interface IconProps {
  size?: number;
  className?: string;
  'aria-hidden'?: boolean | 'true' | 'false';
  'aria-label'?: string;
}

export const NaIcon = (_: IconProps): ReactElement => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_9508_24016)">
      <path
        d="M7 13.5C10.5899 13.5 13.5 10.5899 13.5 7C13.5 3.41015 10.5899 0.5 7 0.5C3.41015 0.5 0.5 3.41015 0.5 7C0.5 10.5899 3.41015 13.5 7 13.5Z"
        stroke="#019CDE"
      />
      <path
        d="M7.59883 10.911H6.39883V5.25895H7.59883V10.911ZM6.32583 3.76195C6.31955 3.67202 6.33166 3.58176 6.3614 3.49665C6.39114 3.41155 6.4379 3.3334 6.49883 3.26695C6.56652 3.20632 6.64557 3.15972 6.7314 3.12986C6.81722 3.09999 6.90812 3.08745 6.99883 3.09295C7.08961 3.08659 7.18074 3.09873 7.26669 3.12864C7.35264 3.15855 7.43161 3.20561 7.49883 3.26695C7.56093 3.33374 7.60861 3.41261 7.63889 3.49863C7.66917 3.58465 7.6814 3.67599 7.67483 3.76695C7.67907 3.85436 7.66568 3.94173 7.63544 4.02385C7.6052 4.10597 7.55874 4.18117 7.49883 4.24495C7.4328 4.30607 7.35508 4.35317 7.27035 4.38342C7.18561 4.41367 7.09563 4.42644 7.00583 4.42095C6.91381 4.42749 6.82141 4.41526 6.73426 4.385C6.64711 4.35475 6.56701 4.3071 6.49883 4.24495C6.43883 4.18033 6.39256 4.1042 6.36283 4.02119C6.33309 3.93817 6.3205 3.84998 6.32583 3.76195Z"
        fill="#019CDE"
      />
    </g>
    <defs>
      <clipPath id="clip0_9508_24016">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
